import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import config from '@/config';
import api from '@/shared/api';
import { useEffect, useState } from 'react';
import AutoComplete from '@/shared/components/input/select/AutoComplete';
const fetchFolders = async (siteId, driveId, folderId) => {
    const url = folderId
        ? `${config.appUrls.documents}/api/sharepoint/sites/${siteId}/drives/${driveId}/folders/${folderId}/folders`
        : `${config.appUrls.documents}/api/sharepoint/sites/${siteId}/drives/${driveId}/folders`;
    const { data } = await api.base.get(url);
    return data;
};
export const SharepointFolderTree = ({ siteId, driveId, onSelectedFolderChanged, setLoading, }) => {
    var _a, _b;
    const [folderCache, setFolderCache] = useState({});
    const [selectedFolders, setSelectedFolders] = useState([]);
    useEffect(() => {
        setSelectedFolders([]);
    }, [siteId]);
    useEffect(() => {
        setSelectedFolders([]);
        if (!siteId || !driveId) {
            onSelectedFolderChanged('/');
            return;
        }
        if (!folderCache[driveId]) {
            setLoading(true);
            fetchFolders(siteId, driveId).then(x => {
                setFolderCache(Object.assign(Object.assign({}, folderCache), { [driveId]: !x ? [] : x }));
                setLoading(false);
            });
        }
    }, [driveId]);
    useEffect(() => {
        if (!siteId || !driveId) {
            onSelectedFolderChanged('/');
            return;
        }
        for (let i = 0; i < selectedFolders.length; i++) {
            const selectedFolder = selectedFolders[i];
            if (selectedFolder === '/')
                continue;
            if (!folderCache[selectedFolder]) {
                setLoading(true);
                fetchFolders(siteId, driveId, selectedFolder).then(x => {
                    setFolderCache(Object.assign(Object.assign({}, folderCache), { [selectedFolder]: x }));
                    setLoading(false);
                });
            }
        }
    }, [selectedFolders]);
    if (!siteId || !driveId || !folderCache[driveId])
        return (_jsx(AutoComplete, { mode: "edit", disabled: true, items: [{ key: '/', label: '/' }], value: { key: '/', label: '/' }, onChange: () => { }, canClear: false }));
    const subfolderSelected = (folderId, index) => {
        const newSelectedFolders = [];
        for (let i = 0; i < index; i++) {
            newSelectedFolders.push(selectedFolders[i]);
        }
        setSelectedFolders([...newSelectedFolders, folderId]);
        onSelectedFolderChanged(folderId);
    };
    const rootItems = [{ key: '/', label: '/' }, ...folderCache[driveId].map(f => ({ key: f.id, label: f.name }))];
    const rootValue = selectedFolders[0] && selectedFolders[0] !== '/'
        ? { key: selectedFolders[0], label: (_b = (_a = folderCache[driveId].find(f => f.id === selectedFolders[0])) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '' }
        : { key: '/', label: '/' };
    const renderSubFolders = () => {
        var _a, _b, _c;
        const elements = [];
        for (let i = 0; i < selectedFolders.length; i++) {
            const selectedFolder = selectedFolders[i];
            if (selectedFolder === '/' || !((_a = folderCache[selectedFolder]) === null || _a === void 0 ? void 0 : _a.length))
                break;
            const subItems = [{ key: '/', label: '/' }, ...folderCache[selectedFolder].map(f => ({ key: f.id, label: f.name }))];
            const subValue = selectedFolders[i + 1] && selectedFolders[i + 1] !== '/'
                ? { key: selectedFolders[i + 1], label: (_c = (_b = folderCache[selectedFolder].find(f => f.id === selectedFolders[i + 1])) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : '' }
                : { key: '/', label: '/' };
            elements.push(_jsx("div", Object.assign({ className: "margin5B" }, { children: _jsx(AutoComplete, { mode: "edit", items: subItems, value: subValue, onChange: item => { var _a; return subfolderSelected((_a = item === null || item === void 0 ? void 0 : item.key) !== null && _a !== void 0 ? _a : '/', i + 1); }, canClear: false }) }), selectedFolder));
        }
        return elements;
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: "margin5B" }, { children: _jsx(AutoComplete, { mode: "edit", items: rootItems, value: rootValue, onChange: item => { var _a; return subfolderSelected((_a = item === null || item === void 0 ? void 0 : item.key) !== null && _a !== void 0 ? _a : '/', 0); }, canClear: false }) })), renderSubFolders()] }));
};
